import React, { useEffect, useState } from 'react';
import { Field } from 'redux-form';
import { codigoDocumento, tipoDocumentoReferencia } from '../../catalogos';
import { renderInput, renderSelect, renderTextArea } from '../../util';
import DatePicker, { formatDates, normalizeDates } from '../datePicker/DatePicker';
import { connect } from 'react-redux';
import { documentTypeEnum } from '../../enum';
import { setLocalForm } from '../../actions';
import Receptor from '../nuevoDocumento/Receptor';

const RenderReferenciaDocumento = (props) => {
    const { localFormState, docType } = props;
    const [mostrarCampo, setMostrarCampo] = useState(true);

    useEffect(() => {
        if (docType === documentTypeEnum.Factura || docType === documentTypeEnum.FacturaCompra || docType === documentTypeEnum.Tiquete) {
            setMostrarCampo(false)
        }
    }, [localFormState?.InformacionReferencia]);

    return ((docType !== documentTypeEnum.FacturaCompra) &&
        <>
            <div className="titulo-informacion-referencia">
                <h3>Referencia del Documento</h3>
            </div>

            {
                mostrarCampo && <div className="ui grid">
                    <div className="sixteen wide column">
                        <Field
                            label="Fecha"
                            name="InformacionReferencia.FechaEmision"
                            component={DatePicker}
                            parse={normalizeDates}
                            format={formatDates}
                            placeholder="DD-MM-AAAA"
                        />
                    </div>
                </div>
            }

            <div className="ui stackable two column grid">
                {
                    mostrarCampo &&
                    <> <div className="column eight">
                        <Field
                            name="InformacionReferencia.TipoDoc"
                            label="Tipo de Documento"
                            component={renderSelect}
                            type="select"
                            options={tipoDocumentoReferencia}
                            onChange={(e) =>  props.setLocalForm({
                                    ...localFormState,
                                    InformacionReferencia: {
                                        ...localFormState.InformacionReferencia,
                                        TipoDoc: e.target.value
                                    },
                                    Receptor: null
                                  })}
                        />
                    </div>
                        <div className="column eight">
                            <Field
                                label="Código de Documento"
                                component={renderSelect}
                                type="select"
                                options={codigoDocumento}
                                name="InformacionReferencia.Codigo"
                            />
                        </div>
                    </>}
                <div className="sixteen wide column">
                    <Field
                        label="Número de Documento"
                        component={renderInput}
                        name="InformacionReferencia.Numero"
                        type="text"
                        maxLength="50"
                    />
                </div>
                <div className="sixteen wide column">
                    <Field
                        label="Razón del Documento"
                        component={renderInput}
                        name="InformacionReferencia.Razon"
                        type="text"
                        maxLength="180"
                    />
                </div>
                <div className="sixteen wide column">
                    <Field
                        label="Notas adicionales"
                        component={renderTextArea}
                        name="Otros.OtroTexto"
                        type="text"
                    />
                </div>
            </div>

        </>
    );
};

const mapStateToProps = (state) => {
    return {
        localFormState: state.localFormState,
    };
}

export default connect(mapStateToProps, {setLocalForm})(RenderReferenciaDocumento);